"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeManager = void 0;
var constants_1 = require("../../constants/constants");
/**
 * Implementation of the ThemeProvider interface for a generic config service.
 * @class
 * @implements {ThemeProvider}
 */
var ThemeManager = /** @class */ (function () {
    function ThemeManager() {
    }
    ThemeManager.prototype.getTheme = function (themeColors) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var theme = {
            background: {
                type: (_b = (_a = themeColors === null || themeColors === void 0 ? void 0 : themeColors.background) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : constants_1.FALLBACK_THEME.BACKGROUND_TYPE,
                from: (_d = (_c = themeColors === null || themeColors === void 0 ? void 0 : themeColors.background) === null || _c === void 0 ? void 0 : _c.from) !== null && _d !== void 0 ? _d : constants_1.FALLBACK_THEME.BACKGROUND_FROM,
                to: (_f = (_e = themeColors === null || themeColors === void 0 ? void 0 : themeColors.background) === null || _e === void 0 ? void 0 : _e.to) !== null && _f !== void 0 ? _f : constants_1.FALLBACK_THEME.BACKGROUND_TO,
            },
            textColor: (_g = themeColors.textColor) !== null && _g !== void 0 ? _g : constants_1.FALLBACK_THEME.TEXT_COLOR,
            primary: (_h = themeColors.primary) !== null && _h !== void 0 ? _h : constants_1.FALLBACK_THEME.PRIMARY,
            secondary: (_j = themeColors.secondary) !== null && _j !== void 0 ? _j : constants_1.FALLBACK_THEME.SECONDARY,
            neutral: (_k = themeColors.neutral) !== null && _k !== void 0 ? _k : constants_1.FALLBACK_THEME.NEUTRAL,
            success: (_l = themeColors.success) !== null && _l !== void 0 ? _l : constants_1.FALLBACK_THEME.SUCCESS,
            warning: (_m = themeColors.warning) !== null && _m !== void 0 ? _m : constants_1.FALLBACK_THEME.WARNING,
            danger: (_o = themeColors.danger) !== null && _o !== void 0 ? _o : constants_1.FALLBACK_THEME.DANGER,
            info: (_p = themeColors.info) !== null && _p !== void 0 ? _p : constants_1.FALLBACK_THEME.INFO,
        };
        return theme;
    };
    return ThemeManager;
}());
exports.ThemeManager = ThemeManager;
